// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import CaretDownFilledSvg from "@ant-design/icons-svg/lib/asn/CaretDownFilled";
import AntdIcon from "../components/AntdIcon";
const CaretDownFilled = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: CaretDownFilledSvg
    });
if (process.env.NODE_ENV !== "production") {
    CaretDownFilled.displayName = "CaretDownFilled";
}
export default /*#__PURE__*/ React.forwardRef(CaretDownFilled);
